import { Dialog, DialogTitle, IconButton } from "@mui/material"
import { Close } from "@mui/icons-material"
import FactorRulesSearch from "../search"
import type { FactorRulesSearchProps } from "../types"
import { FACTOR_RULE_DISPLAY_TYPES } from "../constants"

interface FactorRulesSearchModalProps extends FactorRulesSearchProps {
  isOpen: boolean
  onClose: () => void
  container?: HTMLElement | null
}

export default function FactorRulesSearchModal({
  isOpen,
  onClose,
  ruleDisplayType,
  container,
  ...factorRulesSearchProps
}: FactorRulesSearchModalProps) {
  const ruleType = ruleDisplayType === FACTOR_RULE_DISPLAY_TYPES.EXPOSURE ? "Exposure" : "Composition"
  const title = `Search ${ruleType} Targets`

  return (
    <Dialog className="factor-rules-search-modal" open={isOpen} container={container} onClose={onClose}>
      <DialogTitle>
        {title}
        <IconButton aria-label="close" onClick={onClose} size="large">
          <Close />
        </IconButton>
      </DialogTitle>

      <FactorRulesSearch
        {...factorRulesSearchProps}
        ruleDisplayType={ruleDisplayType}
      />
    </Dialog>
  )
}
